import { render, staticRenderFns } from "./ProjectShowReportsTab.vue?vue&type=template&id=2d9fbb5a"
import script from "./ProjectShowReportsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowReportsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports